export default __webpack_public_path__ + "static/media/StoryType.7ddf3283.svg";